module.exports = __webpack_public_path__ + "media/images/connect-with-strava-9c6f79ae.svg";